<template>
  <div class="view-tools">
    <button
      class="btn btn-menu mobile-only"
      @click="isMobileMenuOpen = !isMobileMenuOpen"
    >
      <i
        :class="{ 'icon-menu': !isMobileMenuOpen, 'icon-x': isMobileMenuOpen }"
      ></i>
    </button>
    <action-dispatcher action="tools/getAiTools">
      <aside :class="{ 'desktop-only': !isMobileMenuOpen }">
        <button
          class="menu-button"
          v-for="(tool, index) in tools"
          :key="index"
          :class="{ active: current === tool.slug }"
          @click="onClickMenu(tool.slug)"
        >
          <img v-if="tool.image" :src="tool.image" alt="tool" />
          <i :class="tool.icon" v-else />
          <span>
            {{ tool.title }}
          </span>
        </button>
      </aside>
    </action-dispatcher>
    <div class="flex-fill tool container-fluid">
      <div v-if="!currentTool" class="tool-component">
        <h5>Bem-vindo às Ferramentas!</h5>
        <p>Selecione uma opção no menu lateral para começar</p>
      </div>
      <component
        v-else
        :is="currentTool.component"
        class="tool-component"
        :code="currentTool.code"
      />
    </div>
  </div>
</template>
<script>
import BenefitsClub from "@/components/tools/BenefitsClub.vue";
import IAChat from "@/components/tools/IAChat.vue";
import Scholarships from "@/components/tools/Scholarships.vue";
import Documents from "@/components/tools/Documents.vue";
import Calendar from "@/components/tools/Calendar.vue";
import Simulators from "@/components/tools/Simulators.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      isMobileMenuOpen: false,
      current: this.$route.params.slug || "amy"
    };
  },
  computed: {
    ...mapState("tools", ["aiTools"]),
    tools() {
      return [
        {
          slug: "simulators",
          title: "Simuladores (SAT, GRE, TOEFL,...)",
          component: Simulators,
          image: require("../assets/images/simulators.svg")
        },
        ...this.aiTools
          .filter(tool => !tool.is_simulator)
          .map(tool => {
            return {
              slug: tool.slug,
              title: tool.name,
              component: IAChat,
              code: tool.iframe_code,
              icon: tool.icon ? `far fa-${tool.icon}` : null,
              image: tool.icon_image
            };
          }),
        {
          slug: "scholarships",
          title: "Bolsas e Oportunidades",
          component: Scholarships,
          icon: "far fa-briefcase"
        },
        {
          slug: "club",
          title: "Clube de Benefícios",
          component: BenefitsClub,
          icon: "far fa-shopping-cart"
        },
        {
          slug: "documents",
          title: "Correção de Documentos",
          component: Documents,
          icon: "far fa-file"
        },
        {
          slug: "calendar",
          title: "Programação do Mês",
          component: Calendar,
          icon: "far fa-calendar"
        }
      ];
    },
    currentTool() {
      return this.tools.find(tool => tool.slug === this.current);
    }
  },
  methods: {
    onClickMenu(slug) {
      this.$router.push({ params: { slug } });
      this.isMobileMenuOpen = false;
    }
  }
};
</script>

<style lang="scss">
.view-tools {
  margin-top: 80px;
  $component-height: 80vh;
  $aside-width: 300px;

  @media screen and (min-width: 992px) {
    display: flex;
  }

  .btn-menu {
    color: white;

    i {
      font-size: 24px;
    }
  }

  aside {
    padding: 24px 16px;
    border-right: 1px solid rgba(55, 55, 55, 1);
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media screen and (min-width: 992px) {
      min-width: $aside-width;
      min-height: $component-height;
    }

    button {
      align-items: center;
      background-color: unset;
      border: none;
      border-radius: 8px;
      color: white;
      display: grid;
      grid-template-columns: 24px 1fr;
      column-gap: 12px;
      padding: 12px 16px;
      text-align: left;
      transition: background-color 0.2s;

      &.active,
      &:hover {
        background-color: rgba(0, 0, 0, 1);
      }

      img,
      i {
        width: 24px;
        height: 24px;
        font-size: 20px;
      }
    }
  }

  .tool {
    @media screen and (min-width: 992px) {
      max-width: calc(100% - #{$aside-width});
    }

    &:has(.blog-article) {
      .tool-title {
        display: none;
      }
    }

    .tool-title {
      width: 100%;
      border-radius: 8px;
      color: white;
      background-color: rgba(25, 25, 25, 1);
      padding: 16px;
      font-size: 18px;
      font-weight: 600;
    }

    .tool-component {
      width: 100%;
      min-height: calc($component-height - 48px);
      margin-top: 24px;
    }
  }
}
</style>
